<template>
  <form>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" value="" :id="this.item_id" v-model="checked" @change="toggle()">
      <label class="form-check-label" :for="this.item_id">
        {{ label }}
      </label>
    </div>
    <div class="w-100 my-1">
      <i v-if="saveInProgress" class="fa-solid fa-spinner fa-spin-pulse fa-spin-reverse"></i>
      <span v-if="saved" class="text-success fw-bold">{{ saved_message }}</span>
    </div>
  </form>
</template>

<script>
export default {
  data () {
      return {
          checked: false,
          saved: false,
          saveInProgress: false
      };
  },

  methods: {
    toggle: function() {
      this.saved = false;
      this.saveInProgress = true;

      axios.post(this.post_url, {
          checked: this.checked,
          property: this.post_property,
      })
      .then((response) => {
          const data = response.data;
          this.checked
          if (data === true || data === false) {
            this.checked = data;
            this.saved = true;
          }
          this.saveInProgress = false;
      });
    }
  },

  props: [
      'item_id',
      'initial_value',
      'label',
      'post_property',
      'post_url',
      'saved_message'
  ],

  created() {
    this.checked = this.initial_value == 1 ? true : false;
  }
}
</script>
